import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "example",
  class: "table table-striped",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "fw-bolder text-muted" }
const _hoisted_3 = {
  key: 0,
  class: "table-head"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "table-head min-w-125px"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "table-head"
}
const _hoisted_8 = {
  key: 3,
  class: "table-head"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 4,
  class: "table-head"
}
const _hoisted_11 = {
  key: 5,
  class: "table-head"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "GU Email ID", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 6,
  class: "table-head"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "Principal Investigator", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 7,
  class: "table-head"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "User", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 8,
  class: "table-head"
}
const _hoisted_21 = {
  key: 9,
  class: "table-head"
}
const _hoisted_22 = {
  key: 10,
  class: "table-head"
}
const _hoisted_23 = {
  key: 11,
  class: "table-head min-w-125px"
}
const _hoisted_24 = {
  key: 12,
  class: "table-head min-w-125px"
}
const _hoisted_25 = {
  key: 13,
  class: "table-head min-w-125px"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 14,
  class: "table-head"
}
const _hoisted_28 = {
  key: 15,
  class: "table-head min-w-125px"
}
const _hoisted_29 = {
  key: 16,
  class: "table-head min-w-125px"
}
const _hoisted_30 = {
  key: 17,
  class: "table-head"
}
const _hoisted_31 = {
  key: 18,
  class: "table-head"
}
const _hoisted_32 = {
  key: 19,
  class: "table-head"
}
const _hoisted_33 = {
  key: 20,
  class: "table-head"
}
const _hoisted_34 = {
  key: 21,
  class: "table-head"
}
const _hoisted_35 = {
  key: 22,
  class: "table-head"
}
const _hoisted_36 = {
  key: 23,
  class: "table-head"
}
const _hoisted_37 = {
  key: 24,
  class: "table-head"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "Phone Number", -1)
const _hoisted_39 = {
  key: 25,
  class: "table-head"
}
const _hoisted_40 = {
  key: 26,
  class: "table-head"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick", "title"]
const _hoisted_47 = ["onClick", "title"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { key: 0 }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  class: "btn btn-primary btn-sm px-4 me-2",
  type: "button"
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  key: 1,
  class: "mt-6 mb-10 d-flex flex-row-reverse"
}
const _hoisted_77 = {
  key: 1,
  class: "col-1",
  style: {"max-width":"70px"}
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationTableActionFilter = _resolveComponent("ApplicationTableActionFilter")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.pagination)
      ? (_openBlock(), _createBlock(_component_ApplicationTableActionFilter, {
          key: 0,
          filtersDisabled: _ctx.hiddeSearchBar,
          hideRadio: _ctx.hideRadio,
          tableCallFunction: _ctx.tableCallFunction
        }, null, 8, ["filtersDisabled", "hideRadio", "tableCallFunction"]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_2, [
          (_ctx.tableColumns?.includes(`tlEventDate`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_3, [
                _createTextVNode(" Event Date "),
                _hoisted_4,
                _createTextVNode(" Event Hour ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`tlEventDescription`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_5, [
                _createTextVNode(" Event Name "),
                _hoisted_6,
                _createTextVNode(" Event Description ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`irbid`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_7, " IRB ID " + _toDisplayString(_ctx.tableColumns?.includes(`notificationFormId`)
              ? " - Notification Id"
              : ""), 1))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`txresearchtitle`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_8, [
                _createTextVNode(" Type of review "),
                _hoisted_9,
                _createTextVNode("Title of the research ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`researchtitle`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_10, " Title of the research "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`piinfo`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_11, _hoisted_13))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`piinfo`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_14, _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`tlUser`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`appStatus`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_20, " Status "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`reviewtype`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_21, " Type of Review "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`requestedFaculty`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_22, " Requested "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`requestedFacultyStatus`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_23, " Status "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`requestedIrbMemberStatus`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_24, " Status "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`notificationFormSubmissionDate`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_25, [
                _createTextVNode(" Submission Date "),
                (_ctx.tableColumns?.includes(`notificationFormAssigned`))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, " / Status"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`requestedIrbMembersAssignedDate`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_27, " Assigned "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`notificationFormAssigned`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_28, " Assigned "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`notificationFormType`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_29, " Type "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`submittedDate`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_30, " Submitted "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`reviewerEmail`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_31, " Reviewer Information "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`approvalDate`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_32, " Date of Approval "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`notificationFormDecision`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_33, " Actions "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`notificationAlertMessage`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_34, " Message "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`notificationAlertCreated`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_35, " Notification Date "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`user`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_36, " Email / Phone "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`user`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_37, [
                _createTextVNode(" Full Name "),
                _hoisted_38
              ]))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`user`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_39, " User Type "))
            : _createCommentVNode("", true),
          (_ctx.tableColumns?.includes(`user`))
            ? (_openBlock(), _createElementBlock("th", _hoisted_40, " Registered "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (app, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: "mouseHover"
          }, [
            (_ctx.tableColumns?.includes(`tlEventDate`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.momentMDY(app.transactionLogDate)) + " ", 1),
                  _hoisted_42,
                  _createTextVNode(" " + _toDisplayString(_ctx.momentHour(app.transactionLogDate)), 1)
                ], 8, _hoisted_41))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`tlEventDescription`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 1,
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, [
                  _createTextVNode(_toDisplayString(app.transactionLogName) + " ", 1),
                  _hoisted_44,
                  _createTextVNode(" " + _toDisplayString(app.transactionLogAction), 1)
                ], 8, _hoisted_43))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`irbid`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 2,
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(app.applicationCode || app.irbApplicationId) + " " + _toDisplayString(_ctx.tableColumns?.includes(`notificationFormId`)
                ? "-" + app.notificationId
                : ""), 9, _hoisted_45))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`researchtitle`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 3,
                  class: "title",
                  style: {"text-overflow":"ellipsis","white-space":"nowrap","overflow":"hidden","max-width":"90px"},
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall)),
                  title: app.irbTitle
                }, _toDisplayString(app.irbTitle), 9, _hoisted_46))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`txresearchtitle`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 4,
                  class: "title",
                  style: {"text-overflow":"ellipsis","white-space":"nowrap","overflow":"hidden","max-width":"90px"},
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall)),
                  title: app.irbTitle
                }, [
                  _createTextVNode(_toDisplayString(app.typeOfReview), 1),
                  _hoisted_48,
                  _createTextVNode(_toDisplayString(app.irbTitle), 1)
                ], 8, _hoisted_47))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`piinfo`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 5,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, [
                  _createElementVNode("div", null, _toDisplayString(app.user ? app.user.email : "" || app.piEmail), 1)
                ], 8, _hoisted_49))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`piinfo`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 6,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, [
                  _createElementVNode("div", null, _toDisplayString(app.piFirstname + " " + app.piLastName), 1)
                ], 8, _hoisted_50))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`tlUser`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 7,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(app.piFirstname + " " + app.piLastName) + " ", 1),
                    _hoisted_52,
                    _createTextVNode(_toDisplayString(app.user ? app.user.email : "" || app.piEmail), 1)
                  ])
                ], 8, _hoisted_51))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`appStatus`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 8,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(app.appStatus), 9, _hoisted_53))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`reviewtype`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 9,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(app.typeOfReview), 9, _hoisted_54))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`requestedFaculty`))
              ? (_openBlock(), _createElementBlock("th", {
                  key: 10,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(_ctx.momentMDY(app.facultyRequestedDate)), 9, _hoisted_55))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`requestedFacultyStatus`))
              ? (_openBlock(), _createElementBlock("th", {
                  key: 11,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(app.facultyResuestedStatus), 9, _hoisted_56))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`requestedIrbMemberStatus`))
              ? (_openBlock(), _createElementBlock("th", {
                  key: 12,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(app.reviewerStatusDescription), 9, _hoisted_57))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`notificationFormSubmissionDate`))
              ? (_openBlock(), _createElementBlock("th", {
                  key: 13,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.momentMDY(app.notifcationCreatedDate)) + " ", 1),
                  (_ctx.tableColumns?.includes(`notificationFormAssigned`))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(app.notifcationStatus), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_58))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`requestedIrbMembersAssignedDate`))
              ? (_openBlock(), _createElementBlock("th", {
                  key: 14,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(_ctx.momentMDY(app.reviewerAssignedDate)), 9, _hoisted_60))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`notificationFormAssigned`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 15,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeActionDecision(app, _ctx.functionToCallDecision))
                }, [
                  _createElementVNode("div", null, _toDisplayString(app.notifcationAssignedUserEmail), 1),
                  _hoisted_62,
                  _createElementVNode("div", null, _toDisplayString(app.notifcationAssigned), 1)
                ], 8, _hoisted_61))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`notificationFormType`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 16,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeActionDecision(app, _ctx.functionToCallDecision))
                }, [
                  _createElementVNode("div", null, _toDisplayString(app.notifcationType), 1)
                ], 8, _hoisted_63))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`submittedDate`))
              ? (_openBlock(), _createElementBlock("th", {
                  key: 17,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(_ctx.momentMDY(app.submittedDate)), 9, _hoisted_64))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`reviewerEmail`))
              ? (_openBlock(), _createElementBlock("th", {
                  key: 18,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, [
                  _createElementVNode("div", null, _toDisplayString(app.reviewerEmail), 1),
                  _hoisted_66,
                  _createElementVNode("div", null, _toDisplayString(app.reviewerFirstName + " " + app.reviewerLastName), 1)
                ], 8, _hoisted_65))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`approvalDate`))
              ? (_openBlock(), _createElementBlock("th", {
                  key: 19,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(_ctx.momentMDY(app.irbDate)), 9, _hoisted_67))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`notificationFormDecision`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 20,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeActionDecision(app, _ctx.functionToCallDecision))
                }, [
                  _createElementVNode("button", _hoisted_69, _toDisplayString(_ctx.functionToCallName), 1)
                ], 8, _hoisted_68))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`notificationAlertMessage`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 21,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(app.notifcationAlertMessage), 9, _hoisted_70))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`notificationAlertCreated`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 22,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(_ctx.momentMDY(app.notifcationAlertMessageCreated)), 9, _hoisted_71))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`user`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 23,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(app.piEmail), 9, _hoisted_72))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`user`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 24,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, [
                  _createTextVNode(_toDisplayString(app.piFirstname + " " + app.piLastName) + " ", 1),
                  _createElementVNode("p", null, _toDisplayString(app.piPhoneNumber), 1)
                ], 8, _hoisted_73))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`user`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 25,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(app.piRole), 9, _hoisted_74))
              : _createCommentVNode("", true),
            (_ctx.tableColumns?.includes(`user`))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 26,
                  class: "title",
                  onClick: ($event: any) => (_ctx.executeAction(app, _ctx.functionToCall))
                }, _toDisplayString(_ctx.moment(app.createdDate)), 9, _hoisted_75))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    (_ctx.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
          _createVNode(_component_el_pagination, {
            layout: "sizes, prev,  pager,  next, total",
            "page-sizes": [8, 20, 30, 40],
            "default-current-page": _ctx.pagination.defaultPage,
            "current-page": _ctx.pagination.page,
            "page-size": _ctx.pagination.recordsPerPage,
            total: _ctx.pagination.totalCount,
            onCurrentChange: _cache[0] || (_cache[0] = (e) => _ctx.changePage(e)),
            onSizeChange: _ctx.changeRows,
            class: "",
            small: "small"
          }, null, 8, ["default-current-page", "current-page", "page-size", "total", "onSizeChange"]),
          false
            ? (_openBlock(), _createBlock(_component_Field, {
                key: 0,
                class: "text-end",
                style: {"width":"55px"},
                type: "number",
                name: "p1",
                modelValue: _ctx.recordsPerPage,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recordsPerPage) = $event)),
                min: "1",
                onchange: (e) => _ctx.changeRows(e)
              }, null, 8, ["modelValue", "onchange"]))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, "Rows per page:"))
            : _createCommentVNode("", true),
          _hoisted_78
        ]))
      : _createCommentVNode("", true)
  ], 64))
}